

const breakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1400,
    xl: 1500,
    xxl: 2200,
  },
};

export default breakpoints;
